import "./style.scss";

import { ButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

import ButtonBase from "../ButtonBase";

type TProps = {
    name: string;
    setSetting: any;
    title: string;
    description: string;
    value: string;
    options: string[];
};

const SettingButtons = (props: TProps) => {
    const { title, description, name, value, setSetting, options } = props;
    const [t] = useTranslation();

    return (
        <div className="setting-buttons">
            <div className="setting-left">
                <div className="setting-title">{title}</div>
                <div className="setting-description">{description}</div>
            </div>
            <div className="setting-right">
                {/* <IosSwitch size="medium" name={name} checked={value} value={value} onChange={setSetting} /> */}
                <ButtonGroup variant="outlined" aria-label="outlined button group">
                    {options?.map((item, i) => (
                        <ButtonBase
                            variant={(value == item && "contained") || "outlined"}
                            onClick={() => setSetting(name, item)}
                            key={i}
                        >
                            {t(`Settings.${item}`)}
                        </ButtonBase>
                    ))}
                </ButtonGroup>
            </div>
        </div>
    );
};

export default SettingButtons;
